jQuery(function($)
{
    var requestUriReplacePatternPageCategory = '[pageCategory]',
        requestUriReplacePatternSearch = '[search]',
        requestUriPattern
			= '/js_catalog/'
				+ requestUriReplacePatternPageCategory
				+ '/language-selection/' + requestUriReplacePatternSearch,

        // module-global variables
        $body = $('body'),
        $container = $('.js-language-selection')
            .find('nav')
            .find('ul'),
        idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    function getRequestUri(pageCategory, search)
    {
        return requestUriPattern
            .replace(requestUriReplacePatternPageCategory, pageCategory)
            .replace(requestUriReplacePatternSearch, search);
    }

    function makeRequestPromise(pageCategory, search)
    {
        var
            requestUri = getRequestUri(pageCategory, search),
            requestId = idLastRequest + 1,

            request = $.ajax({
                'dataType': 'html',
                'url': requestUri
            });

        request.requestId = requestId;
        idLastRequest += 1;

        return request;
    }

    function reload()
    {
        var
            pageCategory = orion.toPageCategory(),
            { search } = document.location,
            request = makeRequestPromise(pageCategory, search);

        function handleDone(markup)
        {
            if (idLastRequest !== request.requestId)
            {
                // stale request => discard
                return;
            }

            if (!markup)
            {
                $container.empty();
            }
            else
            {
                $container.empty().append($(markup).children());
            }
        }

        orion.startProcessing('#custom-filter-options, .js-filter-remove-container');
        request
            .done(handleDone)
        // .done(embellish)
            .fail(function()
            {
            })
            .always(function()
            {
                orion.stopProcessing('#custom-filter-options, .js-filter-remove-container');
            });
    }

    $body.on([orion.constants.EventFiltersChanged, orion.constants.EventSortCriteriumChanged].join(' '), reload);
});
